<template>
	<div class="pa-3">
		<v-data-table :headers="headers" :items="data.items" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<td class="text-xs-center justify-center pa-0" width="75">{{ seqNo(props.index) }}</td>
				<td>{{ props.item.username }}</td>
				<td class="text-xs-left pa-3" v-nl2br>
					{{ props.item.comment }}
				</td>
				<td class="text-xs-center">{{ props.item.publishedOn }}</td>
			</template>
			<template slot="no-data">
				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>
		</v-data-table>

	    <div class="text-xs-right pt-2">
			<v-pagination v-model="currentPage" :length="pages" :total-visible="6"></v-pagination>
	    </div>
	</div>
</template>

<script>
	import * as config from '@/config'

	const numberFormat = function(value) {
	  	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	}

	export default {
		props: {
			contentType: {
				type: String,
				default: null
			},
			contentId: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
				headers: [
					{
						text: '#',
						align: 'right',
						sortable: false,
						width: '50'
					},
					{
						text: 'Login',
						align: 'left',
						width: '20%',
						sortable: false,
					},
					{
						text: 'Comment/Answer',
						align: 'left',
						sortable: false
					},
					{ 
						align: 'Submitted On', 
						align: 'center',
						sortable: false,
						width: '200'
					}
				],
				pageSize: 10,
				loading: true,

				currentPage: 1,
				candidates: [],
			}
		},
		computed: {
			pages () {
				if (this.pageSize == null || this.data.totalRecords == null) {
					return 0
				}
				return Math.ceil(this.data.totalRecords / this.pageSize)
			},
			data () {
				return {
					page: this.currentPage,
					totalRecords: this.candidates.length,
					items: this.candidates.slice((this.currentPage - 1) * this.pageSize, ((this.currentPage - 1) * this.pageSize) + this.pageSize)
				}
			}
		},
		mounted () {
			this.fetchComments()
		},
		methods: {
	    	seqNo (index) {
				return numberFormat(this.data.totalRecords - ((this.data.page - 1) * this.pageSize) - index)
	    	},
	        fetchComments () {
	        	this.loading = true

	        	axios.get(`${config.BASE_URL}/activityTopic/${this.contentId}/candidates/comment`)
	        		.then(response => {
	        			this.candidates = response.data.data

	        			this.loading = false
	        		})
	        		.catch(error => {
	        			this.loading = false
	        		})
	        }
		},
		directives: {
			nl2br: {
				inserted(el) {
					// simplified example, 
					// works only for nodes without any child elements
					let textContent = el.textContent.replace(/\n/g, '<br>').replace('<br />', '<br>').replace('<br>', '<br>')
					do {
						textContent = textContent.replace('<br><br>', '<br>')
					} while (textContent.indexOf('<br><br>') >= 0)

					el.innerHTML = textContent
					// el.innerHTML = el.textContent.replace(/\n/g, '<br>').replace('<br><br>', '<br>').replace('<br><br>', '<br>').replace('<br><br>', '<br>').replace('<br><br>', '<br>')
				}
			}
		}
	}
</script>
